import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faTags, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './CategoriasData.css';
import baseURL from '../../url';
import NewCategoria from '../NewCategoria/NewCategoria';

export default function CategoriasData() {
    const [categorias, setCategorias] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [categoria, setCategoria] = useState({});

    useEffect(() => {
        cargarCategoria();
    }, []);

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(err => console.error('Error al cargar categorías:', err));
    };

    const eliminarCategoria = (idCategoria) => {
        Swal.fire({
            title: '¿Eliminar categoría?',
            text: 'Los productos asignados a esta categoría podrían quedar sin categoría.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/categoriaDelete.php?idCategoria=${idCategoria}`, {
                    method: 'DELETE',
                })
                    .then(res => res.json())
                    .then(data => {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarCategoria();
                    })
                    .catch(err => {
                        console.error('Error al eliminar categoría:', err);
                        toast.error('Error al eliminar');
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setCategoria(item);
        setNuevaCategoria(item.categoria);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idCategoria) => {
        if (!nuevaCategoria.trim()) {
            toast.warn('El nombre de la categoría no puede estar vacío');
            return;
        }

        const payload = {
            categoria: nuevaCategoria,
        };

        fetch(`${baseURL}/categoriaPut.php?idCategoria=${idCategoria}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Actualizado', data.mensaje || 'Categoría actualizada', 'success');
                    cargarCategoria();
                    cerrarModal();
                }
            })
            .catch(err => toast.error(err.message));
    };

    const filtradas = categorias.filter(c => 
        (c.categoria || '').toLowerCase().includes(busqueda.toLowerCase()) ||
        c.idCategoria.toString().includes(busqueda)
    );

    return (
        <div className="adminPageContainer">
            <ToastContainer />

            {/* Cabecera Principal */}
            <div className="adminHeaderSection">
                <div className="adminHeaderTitle">
                    <h2><FontAwesomeIcon icon={faTags} /> Categorías del Menú</h2>
                    <p>Organiza los platos y productos del restaurante en categorías claras e intuitivas.</p>
                </div>
                <div className="adminHeaderActions">
                    <NewCategoria onCategoriaCreated={cargarCategoria} />
                    <button className="adminActionBtn" onClick={cargarCategoria} title="Recargar categorías">
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {/* Toolbar */}
            <div className="adminToolbar">
                <div className="adminSearchBox">
                    <FontAwesomeIcon icon={faSearch} />
                    <input 
                        type="text" 
                        placeholder="Buscar categoría..." 
                        value={busqueda} 
                        onChange={(e) => setBusqueda(e.target.value)} 
                    />
                </div>
                <div className="categoriesSummaryPill">
                    Total: <strong>{categorias.length} categorías</strong>
                </div>
            </div>

            {/* Tabla de Categorías */}
            <div className="adminTableCard">
                <div className="adminTableResponsive">
                    <table className="adminTable">
                        <thead>
                            <tr>
                                <th style={{ width: '80px' }}># ID</th>
                                <th>Nombre de la Categoría</th>
                                <th style={{ textAlign: 'center', width: '120px' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtradas.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="adminEmptyRow">
                                        No se encontraron categorías registradas.
                                    </td>
                                </tr>
                            ) : (
                                filtradas.map(item => (
                                    <tr key={item.idCategoria}>
                                        <td><strong>#{item.idCategoria}</strong></td>
                                        <td>
                                            <span className="categoriaTag" style={{ fontSize: '0.9rem' }}>
                                                <FontAwesomeIcon icon={faTags} /> {item.categoria}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="adminActionBtnGroup" style={{ justifyContent: 'center' }}>
                                                <button 
                                                    className="btnTableAction btnEditar" 
                                                    onClick={() => abrirModal(item)}
                                                    title="Editar categoría"
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button 
                                                    className="btnTableAction btnBorrar" 
                                                    onClick={() => eliminarCategoria(item.idCategoria)}
                                                    title="Eliminar categoría"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal Editar Categoría */}
            {modalVisible && (
                <div className="adminModalOverlay">
                    <div className="adminModalContent modalSmallSimple">
                        <div className="adminModalHeader">
                            <h3>Editar Categoría #{categoria.idCategoria}</h3>
                            <button className="adminModalClose" onClick={cerrarModal}>&times;</button>
                        </div>

                        <div className="adminModalBody">
                            <div className="adminFormField">
                                <label>Nombre de la Categoría:</label>
                                <input 
                                    type="text" 
                                    value={nuevaCategoria} 
                                    onChange={(e) => setNuevaCategoria(e.target.value)}
                                    placeholder="Ej: Entradas, Bebidas, Postres..." 
                                />
                            </div>
                        </div>

                        <div className="adminModalFooter">
                            <button className="adminBtnSecondary" onClick={cerrarModal}>Cancelar</button>
                            <button className="adminBtnPrimary" onClick={() => handleUpdateText(categoria.idCategoria)}>
                                Guardar Cambios
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
